import { CustomSeriesVariantsResult } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class Series<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;
	traceDetails: string | undefined;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
		this.traceDetails = process.env.TRACE_DETAILS?.trim();
	}

	/**
	 * No description
	 *
	 * @tags series
	 * @name SeriesGetVariantsBySeries
	 * @summary Get example products in all colors and dimensions for a series.
	 * @request GET:/store/{storeId}/fca/series/getVariantsBySeries/{catalogId}/{series}
	 * @secure
	 * @response `200` `CustomSeriesVariantsResult` The requested completed successfully.
	 * @response `400` `void` Bad request. Some of the inputs provided to the request aren't valid.
	 * @response `401` `void` Not authenticated. The user session isn't valid.
	 * @response `403` `void` The user isn't authorized to perform the specified request.
	 * @response `404` `void` The specified resource couldn't be found.
	 * @response `500` `void` Internal server error. Additional details will be contained on the server logs.
	 */
	seriesGetVariantsBySeries = (
		storeId: string,
		catalogId: string,
		series?: string | null,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (
			loggerCan('trace') &&
			(!this.traceDetails || this.traceDetails.includes('seriesGetVariantsBySeries'))
		) {
			const paramsLogger = logger.child({
				params,
				query: null ?? {},
				body: null ?? {},
				methodName: 'seriesGetVariantsBySeries',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}
		return this.http.request<CustomSeriesVariantsResult, void>({
			path: `/store/${storeId}/fca/series/getVariantsBySeries/${catalogId}/${series}`,
			method: 'GET',
			secure: true,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
	/**
	 * No description
	 *
	 * @tags series
	 * @name SeriesGetVariantsByCatentryId
	 * @summary Get example products in all colors and dimensions for a series.
	 * @request GET:/store/{storeId}/fca/series/getVariantsByCatentryId/{catalogId}/{catentryId}
	 * @secure
	 * @response `200` `CustomSeriesVariantsResult` The requested completed successfully.
	 * @response `400` `void` Bad request. Some of the inputs provided to the request aren't valid.
	 * @response `401` `void` Not authenticated. The user session isn't valid.
	 * @response `403` `void` The user isn't authorized to perform the specified request.
	 * @response `404` `void` The specified resource couldn't be found.
	 * @response `500` `void` Internal server error. Additional details will be contained on the server logs.
	 */
	seriesGetVariantsByCatentryId = (
		storeId: string,
		catalogId: string,
		catentryId?: string | null,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (
			loggerCan('trace') &&
			(!this.traceDetails || this.traceDetails.includes('seriesGetVariantsByCatentryId'))
		) {
			const paramsLogger = logger.child({
				params,
				query: null ?? {},
				body: null ?? {},
				methodName: 'seriesGetVariantsByCatentryId',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}
		return this.http.request<CustomSeriesVariantsResult, void>({
			path: `/store/${storeId}/fca/series/getVariantsByCatentryId/${catalogId}/${catentryId}`,
			method: 'GET',
			secure: true,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
}
